import { Daphne } from "@syadem/daphne-js";
import { VaccinationAct as ProVaccinationAct } from "@syadem/kairos-pro-js";
import { VaccinationAct as TeamVaccinationAct } from "@syadem/kairos-team-js";
import { LocaleString } from "../translations";
import { dayjs } from "./dayjs";
import { getTranslatedFieldByLocale } from "./translatedFields";
import { printableDiseasesGroups } from "../domain/VaccinationAct";

export const sortByPerformedOnDates = (
  a: ProVaccinationAct | TeamVaccinationAct,
  b: ProVaccinationAct | TeamVaccinationAct,
) => {
  if (a.performedOn < b.performedOn) {
    return 1;
  }
  if (a.performedOn > b.performedOn) {
    return -1;
  }
  return 0;
};

const sameArray = (a: number[], b: number[]) => {
  return a.length === b.length && a.every(x => b.includes(x));
}

export const groupVaccinationActsByDisease = (
  vaccinationActs: ProVaccinationAct[] | TeamVaccinationAct[],
  daphne: Daphne,
  locale: LocaleString,
): Partial<Record<string, ProVaccinationAct[] | TeamVaccinationAct[]>> => {
  return Object.groupBy(vaccinationActs, (vaccination) => {
    const vaccine = daphne.repositories.vaccines.find(vaccination.vaccineId);
    const diseasesCodes = daphne.queries.diseasesByVaccine(vaccine).map((d) => d.code);
    const printableGroup = printableDiseasesGroups.find((g) => sameArray(g, diseasesCodes)) ?? diseasesCodes;

    return printableGroup.map((code) => {
      const disease = daphne.repositories.diseases.all().find((d) => d.code === code);

      if (disease === undefined) return "";

      return getTranslatedFieldByLocale(locale, disease.name)
    }).join(", ");
  })
};

export function isVaccinationBoosterable(
  vaccineId: string,
  birthDate: Date | undefined,
  vaccinationDate: Date | undefined | null,
  daphne: Daphne,
): boolean {
  const diphteriaTetanosPolioIds = [
    "47cac099-7918-4329-9079-bdeb057957f0",
    "ae4a5fbe-9c4a-4836-abd0-da0247cadf42",
    "943d1be1-e2c9-47db-b938-03eab0fac7b0",
  ];
  if (vaccineId === "") return false;

  const vaccine = daphne.repositories.vaccines.find(vaccineId);
  if (vaccine === undefined) return false;

  const diseases = daphne.queries.diseasesByVaccine(vaccine);
  const isMoreOrEqualFive = vaccinationDate ? dayjs(dayjs(vaccinationDate)).diff(birthDate, "year") >= 5 : false;
  const isDiphteriaOrTetanosOrPolio = diseases.some((disease) => diphteriaTetanosPolioIds.includes(disease.id));

  return isMoreOrEqualFive && isDiphteriaOrTetanosOrPolio;
}
